import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';

// slice
import toogleSlice from "./slices/changeMenuStateSlice";
import languageSlice from './slices/changeLanguageSlice';
import currencySlice from './slices/changeCurrencySlice';
import gameCategoriesSlice from './slices/GameCategoriesSlice';
import userDetailSlice from './slices/UserDetailSlice.js';
import providerSlice from './slices/ProviderSlice';
import gameSlice from './slices/GameSlice';
import authSlice from './slices/authSlice.js';
import accountSlice from './slices/changeAccountSlice.js';
import gameLaunchLanguageSlice from './slices/selectGameLaunchLanguageStateSlice';

const persistConfig = {
    key: 'root',
    storage,
}
const rootReducer = combineReducers({
    menuState: toogleSlice,
    languageState: languageSlice,
    currencyState: currencySlice,
    gameCategoryState: gameCategoriesSlice,
    userDetailState: userDetailSlice,
    providerState: providerSlice,
    gameState: gameSlice,
    authState: authSlice,
    accountState:accountSlice,
    gameLaunchLanguageState: gameLaunchLanguageSlice
})

const persistedReducer = persistReducer(persistConfig, rootReducer)

const store = configureStore({
    reducer: persistedReducer,
})

export const persistor = persistStore(store)


export default store




